import { useMutation, useQueryClient } from 'react-query';

import { ItemService } from '../api/GlobalItemService';
import { ItemCost } from '../api/protosCompiled/globalItem/globalItem_pb';

export const useUpdateItemCost = (itemId: string) => {
  const queryClient = useQueryClient();

  return useMutation((data: ItemCost.AsObject) => ItemService.updateItemCost(data), {
    onSuccess: () => {
      queryClient.invalidateQueries(['itemsByFileId', itemId]);

      queryClient.refetchQueries(['itemsByFileId', itemId], {
        exact: true,
      });
    },
    onError: error => {
      console.error('Error updating item cost', error);
    },
  });
};
